export default __webpack_public_path__ + "static/bg_2-cd943a08bfff27e9556bd5929a50a59f.jpg";